import React from 'react';
import { Button, Tooltip } from 'antd';
import { MoonOutlined, SunOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contexts/ThemeContext';

const ThemeToggle: React.FC = () => {
  const { isDark, toggleTheme } = useTheme();
  const { t } = useTranslation();

  const label = isDark
    ? t('common.toggleLightMode', 'Switch to light mode')
    : t('common.toggleDarkMode', 'Switch to dark mode');

  return (
    <Tooltip title={label}>
      <Button
        type="text"
        className={`header-theme-toggle${isDark ? ' header-theme-toggle--active' : ''}`}
        onClick={toggleTheme}
        aria-label={label}
        icon={isDark ? <SunOutlined /> : <MoonOutlined />}
      />
    </Tooltip>
  );
};

export default ThemeToggle;
